import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DeviceLoginInfo, DeviceLoginRedirect } from '@zerops/models/auth';

@Injectable({ providedIn: 'root' })
export class DeviceLoginApi {
  #httpClient = inject(HttpClient);

  info$(requestId: string) {
    return this.#httpClient.get<DeviceLoginInfo>(`/api/auth/device-login/${requestId}`);
  }

  approve$(requestId: string) {
    return this.#httpClient.put<DeviceLoginRedirect>(`/api/auth/device-login/${requestId}/approve`, null);
  }

  deny$(requestId: string) {
    return this.#httpClient.put<DeviceLoginRedirect>(`/api/auth/device-login/${requestId}/deny`, null);
  }
}
